import styled from "styled-components";
import { Classes } from "@blueprintjs/core";

export default styled.div`
display: flex;
flex-direction: column;
padding: 18px;
padding-bottom: 0;
& .${Classes.FORM_GROUP}:last-child {
  margin-bottom: 0;
}
& .${Classes.FORM_GROUP}.${Classes.FORM_GROUP} {
  margin-bottom: 15px;
}
& .${Classes.INPUT} {
  border-radius: 5px;
}
& .${Classes.BUTTON} {
  border-radius: 5px;
}
& .${Classes.LABEL}.${Classes.LABEL} {
  font-size: .9rem;
  margin-bottom: 8px;
}
button {
  outline: none;
}
`;
